/**
 * Shared GraphQL queries — used by both web and mobile.
 *
 * These are plain string queries. After gql.tada setup,
 * replace with: const query = graphql(`...`)
 */

export const CURRENT_USER_QUERY = /* GraphQL */ `
  query CurrentUser {
    currentProfile: profileByUserId(userId: $userId) {
      id
      fullName
      email
      avatarUrl
      preferredLocale
    }
  }
`;

export const ORG_UNITS_QUERY = /* GraphQL */ `
  query OrgUnits {
    allOrgUnits(
      orderBy: [LEVEL_ASC, NAME_ASC]
      condition: { archivedAt: null }
    ) {
      nodes {
        id
        name
        code
        level
        parentId
        isZoological
        headUserId
      }
    }
  }
`;

export const ORG_SETTINGS_QUERY = /* GraphQL */ `
  query OrgSettings {
    allOrgSettings {
      nodes {
        id
        orgId
        currency
        timezone
        aiEnabled
        maxUploadSizeMb
        maxPhotoResolution
        updateChannel
        minVersion
        autoUpdateEnabled
      }
    }
  }
`;

export const USER_PREFERENCES_QUERY = /* GraphQL */ `
  query UserPreferences($userId: UUID!) {
    allUserPreferences(condition: { userId: $userId }, first: 1) {
      nodes {
        id
        darkMode
        language
        notificationEmail
        notificationPush
        notificationSound
        dashboardLayout
        betaTester
      }
    }
  }
`;

export const FEATURE_FLAGS_QUERY = /* GraphQL */ `
  query FeatureFlags {
    allFeatureFlags {
      nodes {
        id
        key
        name
        status
        platform
        description
        moduleKey
      }
    }
    allFeatureFlagOverrides {
      nodes {
        id
        featureFlagId
        orgId
        userId
        enabled
        reason
      }
    }
  }
`;

export const MODULE_LICENSES_QUERY = /* GraphQL */ `
  query ModuleLicenses($orgId: UUID!) {
    allOrgModuleLicenses(condition: { orgId: $orgId, enabled: true }) {
      nodes {
        moduleId
        enabled
        platformModuleByModuleId {
          key
          name
          category
        }
      }
    }
  }
`;
